import * as tslib_1 from "tslib";
import { DrilldownLevelsList } from "../../constants";
import cx from 'classnames';
import { isEqual, last, orderBy } from 'lodash';
import moment from 'moment-timezone';
import * as React from 'react';
import { formatLevelDate, getLevel } from '../../utils/date';
import AmCharts from '../AmCharts';
import DrilldownLevels from './DrilldownLevels';
import Styles from "./TimeLineChart.css";

var TimeLineChart =
/** @class */
function (_super) {
  tslib_1.__extends(TimeLineChart, _super);

  function TimeLineChart() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      drilldownLevelsStyle: {
        display: 'none'
      }
    };

    _this.getDrilldownLevelsStyle = function (chart) {
      return {
        left: chart.realWidth - chart.plotAreaWidth - chart.marginRightReal
      };
    };

    _this.chartRendered = function (_a) {
      var chart = _a.chart;

      _this.setState({
        drilldownLevelsStyle: _this.getDrilldownLevelsStyle(chart)
      });
    };

    _this.showPopover = function (_a) {
      var x = _a.x,
          y = _a.y,
          other = tslib_1.__rest(_a, ["x", "y"]);

      console.warn('showPopover', x, y, other); // eslint-disable-line
    };

    _this.handleClickGraphItem = function (_a) {
      var item = _a.item;
      var canDrilldown = _this.props.canDrilldown;

      if (canDrilldown) {
        var isLastLevel = !_this.drilldown(item.dataContext);

        if (isLastLevel) {
          _this.showPopover(item);
        }
      }
    };

    return _this;
  }

  TimeLineChart.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    var _a = this,
        props = _a.props,
        state = _a.state;

    return props !== nextProps || !isEqual(state, nextState);
  };

  Object.defineProperty(TimeLineChart.prototype, "dataProvider", {
    get: function get() {
      var _a = this.props,
          data = _a.data,
          withBase = _a.withBase,
          baseData = _a.baseData,
          timezone = _a.timezone;
      var chartData = data;

      if (withBase && baseData) {
        //@ts-ignore
        chartData = tslib_1.__spread(chartData, baseData.map(function (_a) {
          var value = _a.value,
              item = tslib_1.__rest(_a, ["value"]);

          return tslib_1.__assign({
            baseValue: value
          }, item);
        }));
      }

      chartData = chartData.map(function (_a) {
        var date = _a.date,
            item = tslib_1.__rest(_a, ["date"]);

        return tslib_1.__assign({
          date: moment.utc(date).tz(timezone).format('YYYY-MM-DD HH:mm:ss'),
          utcDate: moment.utc(date).toISOString()
        }, item);
      });
      return orderBy(chartData, 'date');
    },
    enumerable: true,
    configurable: true
  });

  TimeLineChart.prototype.drilldown = function (_a) {
    var utcDate = _a.utcDate; // extended in dataProvider

    var _b = this.props,
        actions = _b.actions,
        props = tslib_1.__rest(_b, ["actions"]);

    if (!this.props.canDrilldown || !actions.changeDrilldownPoint) {
      // guard for safe
      return;
    }

    var level = getLevel(props);

    if (level !== last(DrilldownLevelsList)) {
      actions.changeDrilldownPoint({
        level: level,
        date: utcDate
      });
      return true;
    }
  };

  TimeLineChart.prototype.render = function () {
    var _a = this.props,
        min = _a.min,
        max = _a.max,
        valueGridCount = _a.valueGridCount,
        canDrilldown = _a.canDrilldown,
        getLabel = _a.getLabel;
    var _b = this.props,
        dateRange = _b.dateRange,
        timezone = _b.timezone,
        drilldownPoint = _b.drilldownPoint,
        actions = _b.actions; // for DrilldownLevels

    var drilldownLevelsStyle = this.state.drilldownLevelsStyle;
    var level = getLevel(this.props);
    var isLastLevel = level === last(DrilldownLevelsList);
    var backgroundColor = '#fff';
    var gridColor = '#f2f2f2';
    var valueLineColor = '#93cd4c';
    var baseValueLineColor = '#bbb';
    var baseAxis = {
      startOnAxis: true,
      axisColor: gridColor,
      boldPeriodBeginning: false,
      gridAlpha: 1,
      gridColor: gridColor
    };
    var baseGraph = {
      balloon: {
        enabled: !isLastLevel
      },
      balloonText: '[[caseCount]] cases',
      bullet: 'round',
      bulletColor: backgroundColor,
      bulletSize: 10,
      bulletBorderAlpha: 1,
      bulletBorderThickness: 3,
      lineThickness: 3,
      showHandOnHover: true,
      useLineColorForBulletBorder: true
    };
    return React.createElement("div", {
      className: Styles.timeLineChart
    }, canDrilldown && actions.changeDrilldownPoint && React.createElement(DrilldownLevels, {
      cx: cx,
      style: drilldownLevelsStyle,
      dateRange: dateRange,
      timezone: timezone,
      drilldownPoint: drilldownPoint,
      actions: actions
    }), React.createElement(AmCharts.React, {
      style: {
        height: '100%',
        position: 'absolute',
        width: '100%'
      },
      options: {
        autoMarginOffset: 0,
        backgroundColor: backgroundColor,
        categoryAxis: tslib_1.__assign({}, baseAxis, {
          autoGridCount: true,
          equalSpacing: true,
          labelFunction: function labelFunction(text, date) {
            return formatLevelDate(level, date);
          },
          minHorizontalGap: 0,
          minPeriod: 'hh',
          parseDates: true
        }),
        categoryField: 'date',
        chartCursor: {
          categoryBalloonFunction: function categoryBalloonFunction(date) {
            return formatLevelDate(level, date);
          },
          cursorAlpha: 0.5,
          cursorColor: valueLineColor,
          graphBulletSize: 1.5,
          limitToGraph: 'valueGraph'
        },
        color: '#bbb',
        dataDateFormat: 'YYYY-MM-DD HH:NN:SS',
        dataProvider: this.dataProvider,
        fontSize: 10,
        graphs: [tslib_1.__assign({}, baseGraph, {
          id: 'valueGraph',
          lineColor: valueLineColor,
          valueField: 'value'
        }), tslib_1.__assign({}, baseGraph, {
          id: 'baseValueGraph',
          lineColor: baseValueLineColor,
          valueField: 'baseValue'
        })],
        listeners: [{
          event: 'rendered',
          method: this.chartRendered
        }, {
          event: 'clickGraphItem',
          method: this.handleClickGraphItem
        }],
        valueAxes: [tslib_1.__assign({}, baseAxis, {
          autoGridCount: false,
          labelFunction: getLabel,
          minimum: min,
          maximum: max,
          gridCount: valueGridCount,
          zeroGridAlpha: 0
        })],
        type: 'serial',
        zoomOutText: ''
      }
    }));
  };

  return TimeLineChart;
}(React.PureComponent);

export default TimeLineChart;